import { Box } from '@dealstack/frontend/shared/components/Box/Box';
import { ConfirmationModal } from '@dealstack/frontend/shared/components/ConfirmationModal/ConfirmationModal';
import { Expandable } from '@dealstack/frontend/shared/components/Expandable/Expandable';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { Divider } from '@dealstack/frontend/shared/components/fundament/Divider/Divider';
import { GenericBooleanStatus } from '@dealstack/frontend/shared/components/GenericStatus/variants/GenericBooleanStatus/GenericBooleanStatus';
import { FullscreenLoader } from '@dealstack/frontend/shared/components/loaders/FullLoaderScreenLoader/FullLoaderScreenLoader';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { TagText, TagPair } from '@dealstack/frontend/shared/components/TagPair/TagPair';
import { EmailForm } from '@dealstack/frontend/admin/pages/Manage/User/ManageUser/EmailForm/EmailForm';
import { NameForm } from '@dealstack/frontend/admin/pages/Manage/User/ManageUser/NameForm/NameForm';
import { useUserController } from '@dealstack/frontend/admin/pages/Manage/User/ManageUser/useUserController';
import { GODMODE_ROOT_ROUTES } from '@dealstack/frontend/admin/pages/Routing/Routing';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ManageUser = () => {
	const {
		user,
		isDataLoading,
		refreshData,
		showSoftDeleteConfirmationModal,
		setShowSoftDeleteConfirmationModal,
		handleSoftDelete,
	} = useUserController();

	if (isDataLoading) {
		return <FullscreenLoader name="pageLoading" />;
	}

	return (
		<div>
			<Link to={GODMODE_ROOT_ROUTES.MANAGE_USER}>
				<Button variant="project">Back to list</Button>
			</Link>
			<br />
			<SectionHeader title={`${user?.firstName} ${user?.lastName}`} subtitle={user?.email} />
			<br />
			<Box>
				<GridBox>
					<TagPair title="User id">
						<TagText>{user?.id}</TagText>
					</TagPair>
					<TagPair title="Active">
						<GenericBooleanStatus value={user?.active} />
					</TagPair>
					<TagPair title="Is deleted">
						<GenericBooleanStatus value={user?.deleted} />
					</TagPair>
				</GridBox>
				<ActionButtonWrapper>
					<Button
						disabled={user?.deleted}
						variant="delete"
						onClick={() => setShowSoftDeleteConfirmationModal(true)}
					>
						Soft delete
					</Button>
					{showSoftDeleteConfirmationModal && (
						<ConfirmationModal
							title="Soft delete user"
							subtitle="Are you sure you want to soft delete user?"
							confirmationButtonText="Soft delete"
							onClose={() => {
								setShowSoftDeleteConfirmationModal(false);
							}}
							onSubmit={handleSoftDelete}
						/>
					)}
				</ActionButtonWrapper>
				<Expandable title="Update user data" initialOpened>
					<NameForm user={user} refreshData={refreshData} />
					<br />
					<Divider />
					<br />
					<EmailForm user={user} refreshData={refreshData} />
				</Expandable>
			</Box>
		</div>
	);
};
const ActionButtonWrapper = styled.div`
	margin-bottom: 1rem;
`;
const GridBox = styled.div`
	display: flex;
	margin-bottom: 2rem;
	overflow: auto;
	& > * {
		margin-right: 2rem;
	}
`;
const _ManageUserExport = memo(ManageUser);

export { _ManageUserExport as ManageUser };
